<template>
	<div>
		
		<div class="toolbar">
				<img class="zanBtn fl" v-show="isshowgift" @click="sendFllowerTap(1)" src="https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_songhua.png">
				<img class="zanBtn fl" v-show="isshowgift" @click="sendFllowerTap(2)" src="https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_dianzan.png">
				<div class="comment">
					<!-- <input class="inputValue" v-model="inputValue" :placeholder="placeholder" v-focus="focusState" @focus="inputFocus" @blur="inputblur" @keyup.enter="sendMsg" id="inputValue" v-if="!isIOS" @click.stop=""> -->
					<div class="inputValue" @click.stop="showcommentBox" >{{placeholder}}</div>
					<img @click="sendMsg" src="https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/Vertical/send.png">
				</div>
			</div>
		<!--ios评论弹窗-->
		<van-popup v-model="commentBox" class="iosPosition">
			<textarea  @click.stop=""  @keyup.enter="sendMsg" class="textarea" v-model="inputValue" :placeholder="placeholder" cols="30" rows="5"></textarea>
			<div class="btnBox">
				<a class="btn" @click="showcommentBox">取消</a>
				<a class="btn" @click="sendMsg">发送</a>
			</div>
		</van-popup>
	</div>
</template>

<script>
import tool from '../../../kits/Tools.js';
import { Toast } from 'vant';
import qs from 'qs'
import Vue from "vue";
import { Popup , Dialog } from 'vant';
import handleIm from '../../../kits/im/handleim.js';
Vue.use(Popup).use(Dialog);

export default {
		data() {
			return {
				fid:'',
				imgPath:'',
				placeholder:"请输入你要发表的内容",
				commentBox:false,
				inputValue:'',
				sendFollowerText:'',
				sendMsgTimer:null
			}
		},
		props:['isWeixin','commentList','isIOS','fans_id','isMaster','ds_id','isshowgift','say_self',"channel_id","uid","verify_comment"],
		mounted() {
			this.imgPath = tool.imgPath();
		},
		methods: {
			showcommentBox(){
				this.commentBox = !this.commentBox;
			},
			sendFllowerTap(type){
				if (type == 1) {
					this.sendFollowerText =
					"送给老师的鲜花<img style='width:20px;ertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/xianhua.png'/>";
				} else if (type == 2) {
					this.sendFollowerText =
					"给老师点个赞<img style='width:20px;vertical-align: bottom;' src='https://tengfaceliveuser.tengface.net/web/wx-user/flower/dianzhan.png'/>";
				}
				this.sendMsg(1);
			},
			
			async sendMsg(type) {
				var that = this;
				let contentText = ""
				if (type == 1) {
					contentText =  this.sendFollowerText 
				} else {
					contentText = this.inputValue ? this.inputValue.replace(/(<|>|&lt;|&gt;)/ig, '#') : ""
				}

				if(contentText.length < 1) {
					Toast('发送消息不能为空');
					return false;
				}

				if (contentText == "@debug") {
					Dialog.alert({ message: location.href ,confirmButtonText: "复制" }).then(() => {
						tool.copyText(location.href);
						Toast("已复制到剪切板");
					});
					this.inputValue = ""
					return
				}

				if (contentText == "@debug2") {
					if (this.channel_id) {
						try {
							const resData = await this.axios.get(`https://livehy.shkt.online/caption/getForChannel?code=${ tool.getQueryChannelId() }`);
							console.log("========",resData)
							if (resData.data.code == 200) {
								const copyData = `公司名称：${resData.data.data.u_name} 渠道ID：${resData.data.data.channel_id} 渠道名称：${resData.data.data.channel_name}  直播间ID：${this.ds_id}`
								Dialog.alert({ 
								message: copyData, 
								confirmButtonText: "复制"
								}).then(() => {
									tool.copyText(copyData);
									Toast("已复制到剪切板");
								});
							}
						} catch (error) {}
					}else{
						try {
							const resData = await this.axios.get(`https://live.shkt.online/liveapi/api/store_data?uid=${ this.uid }`);
							console.log("=====resData===",resData)
							if (resData.data.code == 200) {
							const copyData = `公司名称：${resData.data.data.org_name} 直播间ID：${this.ds_id}`
							Dialog.alert({ 
								message: copyData, 
								confirmButtonText: "复制"
								}).then(() => {
								tool.copyText(copyData);
								Toast("已复制到剪切板");
							});
							}
						} catch (error) {}
					}

					this.inputValue = ""
					return
				}

				if (this.sendMsgTimer) {
					Toast("评论发送太快了");
					return;
				} else {
					this.sendMsgTimer = setTimeout(
					() => {
						clearTimeout(this.sendMsgTimer);
						this.sendMsgTimer = null;
					},
					type == 1 ? 5000 : 1000
					);
				}

				if(that.say_self.enabled && that.say_self.all == 1){//全员自嗨
					that.sendMessageMySelf(contentText,'')
					if (type != 1) {
					   that.inputValue = ""
					}
					that.commentBox = false;
				   return
				}

				if (window.isExceptionMode) { //异常模式
					 that.sendMessageBy505Error(contentText,'')
					 that.quick_id = '';
					 that.fid = '';
					 that.commentBox = false;
				}else{
					var url2 = tool.baseUrl2() + '/comment/index/add';
					var option2 = {
						terminal_type: 1,
						fans_id: this.fans_id,
						ds_id: tool.getDs_id(),
						content: contentText,
						debug: 1,
						fid: this.fid,
					};
					option2 = qs.stringify(option2);
					this.axios.post(url2, option2).then(function(data) {
						var data = data.data;
						if(data.code == "200") {
							// Toast('评论成功');
							that.quick_id = '';
							that.fid = '';
							if (data.data.isCheck) {
								let newObj = Object.assign({}, data.data.content);
								newObj.module = "check_comment";
								handleIm.sendTextMsg(newObj);
							} else {
								handleIm.sendTextMsg(data.data.content);
							}
							that.$emit("comment",data.data.content)
						} else {
							if (that.say_self.enabled) { //开启自嗨
							that.sendMessageMySelf(contentText,'')
							}else{
							Toast(data.message);
							}
						}
						that.commentBox = false;
					}).catch(function(data) {
						Toast('评论失败');
						that.quick_id = '';
						that.fid = '';

						console.log('错误' + data)
					})
				}
				
				if (type != 1) {
				   this.inputValue = ""
				}
			},
			sendMessageMySelf(text,pic_url){
			  let app_id = localStorage.getItem("current_app_Id");
				if (app_id) {
					let userInfo = localStorage.getItem(app_id);
					if (userInfo) {
						let userInfo2 = JSON.parse(userInfo);
						let message  = {
							content: text,
							create_time: tool.getCommentTimes(),
							fans_id: userInfo2.fans_id,
							header: userInfo2.header,
							key: `${tool.getDs_id()}_comment_${(new Date).getTime()}`,
							like_num: 0,
							module: "text_comment",
							nick: userInfo2.nick,
							pic_url: pic_url,
							user_type: "real",
							terminal_type: 1,
							ds_id:tool.getDs_id(),
							_id: `${tool.getDs_id()}_comment_${(new Date).getTime()}`
						}
						this.$emit("comment", message)
						if (this.say_self.type == 1) { //是否发送给助教
							handleIm.sendTextMsg(Object.assign({},message,{module:'my_self_hi'}));
						}
					}
				} 
			},
			sendMessageBy505Error(text,pic_url){
				let app_id = localStorage.getItem("current_app_Id");
				if (app_id) {
					let userInfo = localStorage.getItem(app_id);
					if (userInfo) {
						let userInfo2 = JSON.parse(userInfo);
						let message  = {
							content: text,
							create_time: tool.getCommentTimes(),
							fans_id: userInfo2.fans_id,
							header: userInfo2.header,
							key: `${tool.getDs_id()}_comment_${(new Date).getTime()}`,
							like_num: 0,
							module:"text_comment",
							nick: userInfo2.nick,
							pic_url: pic_url,
							user_type: "real",
							terminal_type: 1,
							ds_id:tool.getDs_id(),
							_id: `${tool.getDs_id()}_comment_${(new Date).getTime()}`
						}
						this.$emit("comment", message)
						if (this.verify_comment) { //审核评论
							let message2 = Object.assign({},message)
							message2.module = "check_comment"
							handleIm.sendTextMsg(message2);
						}else{
							handleIm.sendTextMsg(message);
						}
					}
				} 
			}
		}
	}
</script>

<style scoped>
.toolbar{
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	background: rgba(0,0,0,0.6);
	z-index: 800;
	height: 52px;
	padding: 8px;
	box-sizing: border-box;
	display: flex;
}

.iosPosition  .textarea{
	width: 100%;
	box-sizing: border-box;
}
.zanBtn{
	width: 36px;
	height: 36px;
	margin-right:5px;
}
.comment{
	position: relative;
	display: flex;
	background: rgb(207, 187, 187);
	height: 36px;
	line-height: 36px;
	border-radius: 18px;
	width: 100%;
}
.comment .inputValue{
	width: 100%;
	padding:0 40px 0 20px;
	box-sizing: border-box;
	background: none;
	border: none;
}
.comment img{
	position: absolute;
	top: 2px;
	right: 2px;
	width: 32px;
	height: 32px;
}

.btnBox {
	display: -webkit-box;
	display: -moz-box;
	display: flex;
	text-align: center;
	margin-top: 10px;
	margin-bottom: 10px;
}

.btnBox .btn {
	flex: 1;
	margin: 0 5px;
	height: 42px;
	line-height: 42px;
	color: #fff;
	border-radius: 3px;
	font-size: 16px;
	background: #ccc;
}

.btnBox .btn:last-child {
	background: #3377db;
}

</style>